/* 陸遜傳・第 2 章：宜都・假授初附（建安二十四年，219）
 * 史實：《陸遜傳》「遜徑進，領宜都太守……備宜都太守樊友委郡走，諸城長吏及蠻夷君長皆降。遜請金銀銅印，以假授初附。」
 *       「遜遣將軍李異、謝旌等將三千人，攻蜀將詹晏、陳鳳。異將水軍，旌將步兵，斷色險要，即破晏等，生降得鳳。……
 *       秭歸大姓文布、鄧凱等合夷兵數千人，首尾西方。遜復部旌討破布、凱。布凱脫走，蜀以為將。遜令人誘之，布帥眾還降。」
 * 流程：1. 進宜都，樊友棄郡西逃。
 *       2. 假授初附：四位長吏、君長，文布派說客從峽口去策反。趕在說客到之前授印（讀條）；殺了說客會晚一點再派。三位倒向文布就戰敗。
 *       3. 斷險要：與謝旌的步兵推到峽口，破詹晏；陳鳳剩三成就跪下，站在旁邊生縛（拖太久會逃）。
 *       4. 討破布、凱：文布、鄧凱合夷兵殺來（倒戈的君長也帶兵來），打到兩人脫走。
 *       5. 遜令人誘之：到秭歸路口遣使，文布帥眾還降。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout, vanish } from '../kit.ts';
import { MEN, YIBING, SHU, WU, band, capturable, tickCapture } from './luxun_kit.ts';
import { START, CITY, PASS, ZIGUI, YI, CHIEFS, CHIEF_NAMES } from '../maps/luxun_yidu.ts';

const LV = 10;
const SEND = [36, 24, 44, 32], AGENT_MS = 90, RESEND = 25; // 各君長的說客多久後出發、走多快、被殺後多久再派
const AGENT_FROM = [PASS[0] + 250, PASS[1]];
const SHUB = { spec: SHU, name: '蜀兵', hp: 480, maxHp: 480, atk: 24 };
const YIB = { spec: YIBING, name: '夷兵', hp: 460, maxHp: 460, atk: 24 };

export default {
  id: 'luxun-2', map: 'luxun_yidu', hero: 'luxun',
  title: '第 2 章　宜都・假授初附', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '遜請金銀銅印，以假授初附。', src: '《三國志·吳書·陸遜傳》' }],
    text: '呂蒙白衣渡江，公安、南郡相繼投降。陸遜一路往西，領宜都太守。劉備的宜都太守樊友棄郡而走，各城的長吏和蠻夷君長都來歸附，可是人心還沒定。',
    goals: ['進宜都', '趕在文布的說客之前，把印授給四位長吏、君長', '與謝旌斷險要，破詹晏，生降陳鳳', '討破文布、鄧凱，再遣使誘降文布'],
  },
  words: { ally: '吳兵', foe: '蜀軍' },
  stars: [
    { text: '四印都授出去，沒有人倒向文布', ok: (m) => m.vars.defect === 0 },
    { text: '生降得鳳', ok: (m) => !!(m.vars.cf && m.vars.cf.cap.state === 'bound') },
    { text: '謝旌沒有倒下', ok: (m) => !m.vars.xjDown },
  ],
  steps: [
    { // 0. 樊友委郡走
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.defect = 0; V.sealed = 0;
        V.fy = boss(w, MEN.fanyou, CITY[0] - 200, CITY[1], { name: '樊友', untargetable: true, hp: 9999, caster: false });
        V.fy.home = [V.fy.x, V.fy.y];
        m.line('陸遜', '公安、南郡已下。宜都就在前面。');
        m.mark('city', CITY[0], CITY[1], '宜都');
        m.obj('city', '進宜都');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.fled && SG.gd(me.x, me.y, CITY[0], CITY[1]) < 1100) {
          V.fled = true; V.fy.home = YI.slice(); V.fy.ms = 300;
          m.line('樊友', '吳軍到了！快走、快走！');
          m.after(8, () => vanish(w, V.fy));
        }
        return SG.gd(me.x, me.y, CITY[0], CITY[1]) < 450;
      },
    },
    { // 1. 假授初附
      enter(m, w) {
        const V = m.vars;
        m.done('city'); m.unmark('city');
        m.card('備宜都太守樊友委郡走，諸城長吏及蠻夷君長皆降。遜請金銀銅印，以假授初附。', '《陸遜傳》');
        m.after(5, () => m.line('陸遜', '人心未定，先把印信送到他們手上。'));
        m.after(9, () => m.line('提示', '文布會從峽口派說客去策反。在說客到之前站在長吏、君長身邊授印；殺掉說客，文布要過一陣子才會再派。'));
        V.t0 = w.t;
        V.chiefs = CHIEFS.map(([x, y], i) => {
          const name = CHIEF_NAMES[i];
          const f = m.folk(x, y, { still: true, near: 1, name, look: i % 4 });
          f.i = i; f.state = 'wait'; f.sendAt = SEND[i]; f.agent = null;
          m.mark('c' + i, x, y, name, true);
          return f;
        });
        m.obj('seal', '授印給長吏、君長', CHIEFS.length);
      },
      tick(m, w) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        for (const f of V.chiefs) {
          if (f.state !== 'wait') continue;
          m.chanAt(me, 'c' + f.i, f.x, f.y, 150, 1.5, '授印', () => {
            if (f.state !== 'wait') return;
            f.state = 'sealed'; V.sealed++; m.unmark('c' + f.i); m.line(f.name, '謹受將軍印綬，願為吳臣。');
            if (f.agent && f.agent.alive) rout(m, w, [f.agent], AGENT_FROM);
          }, { hurt: false });
          // 說客：出發、走向君長；到了就策反
          if (!f.agent && t >= f.sendAt) {
            f.agent = m.foe('huangjin', AGENT_FROM[0], AGENT_FROM[1] + (f.i - 1.5) * 60, { spec: YIBING, name: '文布說客', ms: AGENT_MS, hp: 300, maxHp: 300, gold: 40 });
            m.mark('a' + f.i, f.agent.x, f.agent.y, '說客', true, f.agent);
            if (!V.agentSaid) { V.agentSaid = true; m.line('斥候', '峽口那邊有人往山裡去了，像是文布的說客！'); }
          }
          const a = f.agent;
          if (a && !a.alive) { m.unmark('a' + f.i); f.agent = null; f.sendAt = t + RESEND; continue; }
          if (a && a.alive) {
            a.target = null; a.think = 0.5; a.home = [f.x, f.y];
            if (SG.gd(a.x, a.y, f.x, f.y) < 120) {
              f.state = 'defect'; V.defect++; m.unmark('c' + f.i); m.unmark('a' + f.i); vanish(w, a); f.agent = null;
              m.line(f.name, '文布說得是，吳人遠來，豈能久留？');
              m.big(`${f.name}倒向文布`);
              f.hidden = true; f.x = -9999; // 帶著人投文布去了
            }
          }
        }
        m.prog('seal', V.sealed);
        m.get('seal').text = `授印給長吏、君長（已授 ${V.sealed}${V.defect ? `，倒向文布 ${V.defect}` : ''}）`;
        if (V.defect >= 3) { m.lose('宜都諸城復叛'); return false; }
        return V.chiefs.every((f) => f.state !== 'wait');
      },
    },
    { // 2. 斷險要，破晏、生降鳳
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('seal');
        for (const f of V.chiefs) { m.unmark('c' + f.i); m.unmark('a' + f.i); if (f.agent && f.agent.alive) vanish(w, f.agent); }
        m.card('遜遣將軍李異、謝旌等將三千人，攻蜀將詹晏、陳鳳。異將水軍，旌將步兵，斷險要。', '《陸遜傳》');
        V.xj = ally(w, MEN.xiejing, me.x - 120, me.y + 80, LV); V.xj.name = '謝旌';
        V.men = band(m, V.xj, 6, '吳兵', WU, { hp: 520, maxHp: 520, atk: 22 });
        m.after(3, () => m.line('謝旌', '李異的水軍已經沿江上去，斷了他們的退路。步兵隨將軍攻峽口！'));
        V.shu = [];
        for (let i = 0; i < 8; i++) { const u = m.foe('huangjin', PASS[0] - 150 + (i % 4) * 90, PASS[1] - 160 + Math.floor(i / 4) * 300, SHUB); u.home = [u.x, u.y]; V.shu.push(u); }
        V.zy = boss(w, MEN.zhanyan, PASS[0] - 250, PASS[1] - 100, { name: '詹晏', hp: 3000, atk: 55, armor: 7 });
        V.cf = boss(w, MEN.chenfeng, PASS[0] - 250, PASS[1] + 120, { name: '陳鳳', hp: 2800, atk: 50, armor: 7 });
        capturable(V.cf, 0.3);
        m.mark('pass', PASS[0], PASS[1], '峽口');
        m.obj('zy', '破詹晏');
        m.obj('cf', '生降陳鳳（打到他跪下，站在旁邊生縛）');
        m.after(6, () => m.line('陸遜', '陳鳳要活的。'));
      },
      tick(m, w) {
        const V = m.vars;
        if (!V.zy.alive) m.done('zy');
        const C = tickCapture(m, w, V.cf, {
          limit: 18, flee: YI,
          kneel: () => m.line('陳鳳', '……降了，降了！'),
          bound: () => { m.done('cf'); m.line('陸遜', '陳將軍，請。'); vanish(w, V.cf); },
          fled: () => { m.line('陳鳳', '趁他們不注意，走！'); m.get('cf').text = '陳鳳逃走了'; m.get('cf').done = true; },
        });
        const cfDone = !V.cf.alive || C.state === 'bound' || C.state === 'fled';
        if (!V.zy.alive && cfDone) { m.unmark('pass'); return true; }
        return false;
      },
    },
    { // 3. 討破布、凱
      enter(m, w) {
        const me = w.player, V = m.vars;
        rout(m, w, V.shu, YI);
        // 休整：陸遜回滿；謝旌倒下的話扶起來再戰（評星已經記下）
        me.hp = me.maxHp; me.mp = me.maxMp;
        if (!V.xj.alive) { w.revive(V.xj); V.xj.x = me.x - 100; V.xj.y = me.y + 60; }
        if (V.cf.cap.state === 'bound') m.card('即破晏等，生降得鳳。又攻房陵太守鄧輔、南鄉太守郭睦，大破之。', '《陸遜傳》');
        else m.card('即破晏等。又攻房陵太守鄧輔、南鄉太守郭睦，大破之。', '《陸遜傳》');
        m.after(7, () => { m.big('文布、鄧凱合夷兵來攻！'); m.card('秭歸大姓文布、鄧凱等合夷兵數千人，首尾西方。', '《陸遜傳》'); });
        m.after(8, () => {
          const n = 6 + V.defect * 3; // 倒戈的君長帶兵來
          V.yi = [];
          for (let i = 0; i < n; i++) { const u = m.foe('huangjin', 2700 + (i % 4) * 90, PASS[1] - 200 + Math.floor(i / 4) * 130, YIB); u.home = [me.x, me.y]; V.yi.push(u); }
          V.wb = boss(w, MEN.wenbu, 2500, PASS[1] - 80, { name: '文布', hp: 2800, atk: 46, armor: 6 });
          V.dk = boss(w, MEN.dengkai, 2500, PASS[1] + 120, { name: '鄧凱', hp: 2200, atk: 40, armor: 5 });
          for (const b of [V.wb, V.dk]) b.home = [me.x, me.y];
          m.mark('wb', V.wb.x, V.wb.y, '文布', false, V.wb);
          m.obj('wb', '討破文布、鄧凱');
        });
      },
      tick(m, w) {
        const V = m.vars;
        if (!V.wb) return false;
        for (const b of [V.wb, V.dk]) if (b.alive && b.hp < b.maxHp * 0.25 && !b.rout) { b.untargetable = true; b.rout = true; b.home = YI.slice(); b.ms = 320; m.line(b.name, '吳兵勢大，先回秭歸！'); }
        return [V.wb, V.dk].every((b) => !b.alive || b.rout);
      },
    },
    { // 4. 遜令人誘之
      enter(m, w) {
        const V = m.vars;
        m.done('wb'); m.unmark('wb');
        rout(m, w, V.yi.concat([V.wb, V.dk]), YI);
        m.card('遜復部旌討破布、凱。布凱脫走，蜀以為將。', '《陸遜傳》');
        m.after(5, () => m.line('陸遜', '文布是秭歸大姓，與其追殺，不如招他回來。到秭歸路口，派人送信給他。'));
        m.mark('zg', ZIGUI[0] + 400, ZIGUI[1], '遣使');
        m.obj('lure', '到秭歸路口遣使誘降文布');
      },
      tick(m, w) {
        const V = m.vars;
        if (!V.lured) m.chanAt(w.player, 'zg', ZIGUI[0] + 400, ZIGUI[1], 180, 2.5, '遣使', () => {
          V.lured = true; m.done('lure'); m.unmark('zg');
          m.after(4, () => {
            V.wb2 = ally(w, MEN.wenbu, ZIGUI[0] - 200, ZIGUI[1], LV - 1); V.wb2.name = '文布'; V.wb2.hold = [V.wb2.x, V.wb2.y];
            m.line('文布', '布不識天命，蒙將軍不棄，願帥眾還降。');
            m.card('遜令人誘之，布帥眾還降。前後斬獲招納，凡數萬計。', '《陸遜傳》');
          });
          m.after(13, () => m.card('權以遜為右護軍、鎮西將軍，進封婁侯。（〈吳主傳〉：陸遜別取宜都，獲秭歸、枝江、夷道，還屯夷陵，守峽口以備蜀。）', '《陸遜傳》、《吳主傳》'));
          m.after(19, () => m.win());
        });
        return false;
      },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('陸遜陣亡'); return; }
    if (V.xj) { if (!V.xj.alive) V.xjDown = true; allyTick(w, V.xj, me, 520); }
    if (V.wb2) allyTick(w, V.wb2, null, 200);
  },
};
